import { render, staticRenderFns } from "./DispatchTable.vue?vue&type=template&id=69a6ffa1&scoped=true"
import script from "./DispatchTable.vue?vue&type=script&lang=js"
export * from "./DispatchTable.vue?vue&type=script&lang=js"
import style0 from "./DispatchTable.vue?vue&type=style&index=0&id=69a6ffa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6ffa1",
  null
  
)

export default component.exports